import { StorageUtil } from '../../../../shared/utils/storage';

const agencyClientRedirectURLOnLogout = 'agency-client-redirect-url-on-logout';

export const getAgencyClientRedirectURLOnLogout = () =>
  StorageUtil.getItem(agencyClientRedirectURLOnLogout);

export const setAgencyClientRedirectURLOnLogout = () =>
  StorageUtil.setItem(agencyClientRedirectURLOnLogout, '/agency/login');

export const clearAgencyClientRedirectURLOnLogout = () =>
  StorageUtil.removeItem(agencyClientRedirectURLOnLogout);
